export { default } from './Table';
export type { ColumnProps, TableProps } from './Table';
